export default __webpack_public_path__ + "static/Careers_US_Internship_20-a5ff1e6cd6cba44c04f5ef5be9b44b0c.jpg";